import { render, staticRenderFns } from "./FormComunicationModuleStreamax.vue?vue&type=template&id=b3f124a2&scoped=true&"
import script from "./FormComunicationModuleStreamax.vue?vue&type=script&lang=ts&"
export * from "./FormComunicationModuleStreamax.vue?vue&type=script&lang=ts&"
import style0 from "./FormComunicationModuleStreamax.vue?vue&type=style&index=0&id=b3f124a2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3f124a2",
  null
  
)

export default component.exports